export default "__VITE_ASSET__ee9f515d__"